module.exports = __webpack_public_path__ + "static/media/stellarVid.db47dbbd.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stellarVid.mp4
// module id = 243
// module chunks = 0